import { graphql } from "../../services/wp.api.service";

const query = `
mutation PurchaseSingleCredit($paymentToken: String = "", $address: StripeAddress = {}, $promoCode: String = "") {
  purchaseSingleCredit(input: {paymentToken: $paymentToken, address: $address, promoCode: $promoCode}) {
    order {
      date
      id
    }
    clientMutationId
  }
}
`;

const purchaseSingleCredit = (useMutation, id, options) => useMutation(
	["purchaseSingleCredit", id],
	({ paymentToken, address, promoCode }) => graphql({
		query,
		variables: {
			address,
			paymentToken,
			promoCode
		}
	}),
	{
		mutationKey: `purchaseSingleCredit_${id}`,
		...options
	}
);

export default purchaseSingleCredit;
